import { AppUtils } from '../../utils/index';
/**
 * Base class for all damage checkform models.
 */
export class CheckForm {
	private lightboxContent: string;
	private timeStamp: string;

	set LightboxContent(value: string) {
		this.lightboxContent = value;
	}

	get LightboxContent(): string {
		return this.lightboxContent;
	}

	set TimeStamp(value: string) {
		this.timeStamp = value;
	}

	get TimeStamp(): string {
		return this.timeStamp;
	}

	/**
* Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
*/
	public static createFromObject(dataObject: { [key: string]: any }): CheckForm {
		return AppUtils.Helper.createFromMap(dataObject, CheckForm);
	}

}